<template>
  <input-select
    v-model="agencia"
    placeholder="Todas"
    :options="agencias"
    :disabled="disabled"
    :required="required"
    :single="single"
  />
</template>

<script>
export default {
  props: {
    value: null,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    single: { type: Boolean, default: false },
    codigoParceiro: { type: String, default: '' },
    showErrMsg: { type: Boolean, default: true }
  },
  emits: ['input', 'refresh'],
  data () {
    return {
      agencias: []
    }
  },
  computed: {
    agencia: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('refresh')
      }
    }
  },
  watch: {
    codigoParceiro () {
      this.reload()
    }
  },
  beforeMount () {
    this.loadComboAgencias()
  },
  methods: {
    loadComboAgencias () {
      let th = this
      th.agencias = []

      let dto = {
        parameters: [{ name: 'codigoParceiro', value: this.codigoParceiro }]
      }

      th.$api.Agencias.GetAll(dto).then(function (data) {
        if (!data.length || data.length === 0) {
          if (th.showErrMsg)
            th.$api.UI.ShowError(
              'Erro',
              'Não existem agências cadastradas para este banco ou parceiro.'
            )
        } else {
          data.forEach(function (item) {
            th.agencias.push({
              value: item.codigo,
              text: item.numero + '-' + item.digito + ' ' + item.nome
            })
          })
        }
      })
    },
    reload () {
      this.agencia = null
      this.loadComboAgencias()
    }
  }
}
</script>
